export default __webpack_public_path__ + "static/media/new-aboutus.0663a94e.png";